<template>
  <div>
    <v-dialog v-model="value" persistent max-width="800">
      <v-card>
        <div class="text-xs-right" @click="oncancel">
          <v-btn small flat fab><v-icon>close</v-icon></v-btn>
        </div>
        <v-card-text>
          <v-stepper v-model="step" vertical class="elevation-0">
            <v-stepper-step step="1" :complete="step > 1">
              {{ $t('Coupon Info') }}
            </v-stepper-step>
            <v-stepper-content step="1">
              <v-card class="elevation-0 mb-5">
                <div class="form-control" :class="{ 'has-error': errors.has('couponname') }">
                  {{ $t('Coupon Name') }}
                  <input
                    type="text"
                    maxlength="20"
                    v-model="coupon.name"
                    :placeholder="$t('Coupon Name')"
                    name="couponname"
                    :data-vv-as="$t('Coupon Name')"
                    v-validate="'required'"
                  />
                  <span class="text-error" v-if="errors.has('couponname')">{{
                    errors.first('couponname')
                  }}</span>
                </div>
                <div class="form-control" :class="{ 'has-error': errors.has('couponcode') }">
                  {{ $t('Coupon Code') }}
                  <input
                    type="text"
                    maxlength="10"
                    v-model="coupon.code"
                    :placeholder="$t('Coupon Code')"
                    :data-vv-as="$t('Coupon Code')"
                    style="text-transform: uppercase;"
                    name="couponcode"
                    @keypress="onKeyPress"
                    @blur="onBlurCode"
                    v-validate="`required|excluded: ${excludeCoupons}`"
                  />
                  <span class="text-error" v-if="errors.has('couponcode')">{{
                    errors.first('couponcode')
                  }}</span>
                </div>
              </v-card>
              <v-btn color="primary" @click="nextStep(2)" depressed>{{ $t('Next') }}</v-btn>
              <v-btn flat @click="oncancel">{{ $t('cancel') }}</v-btn>
            </v-stepper-content>

            <v-stepper-step step="2" :complete="step > 2">
              {{ $t('Coupon condition') }}
            </v-stepper-step>
            <v-stepper-content step="2">
              <v-card class="elevation-0 mb-5">
                <v-layout wrap>
                  <v-flex xs12 sm6 class="pa-1">
                    <div class="caption">{{ $t('Type of discounts') }}</div>
                    <v-radio-group v-model="coupon.promotype" :data-vv-as="$t('Type of discounts')">
                      <v-radio
                        :label="$t('Price discount')"
                        :value="'price'"
                        color="primary"
                      ></v-radio>
                      <v-radio
                        :label="$t('Quantity discount')"
                        :value="'piece'"
                        color="primary"
                      ></v-radio>
                    </v-radio-group>
                  </v-flex>
                  <v-flex
                    xs12
                    sm6
                    class="form-control pa-1"
                    :class="{ 'has-error': errors.has('promovalue') }"
                  >
                    <template v-if="coupon.promotype == 'price'">
                      <div class="caption">{{ $t('Minimum purchase of') }}</div>
                      <v-layout>
                        <v-flex>
                          <input
                            type="number"
                            v-model="coupon.promovalue"
                            min="0"
                            maxlength="5"
                            max="99999"
                            placeholder="Price"
                            name="promovalue"
                            v-validate="'required|numeric'"
                          />
                          <span class="text-error" v-if="errors.has('promovalue')">{{
                            errors.first('promovalue')
                          }}</span>
                        </v-flex>
                        <v-flex shrink class="pa-2">{{ $t('Baht') }}</v-flex>
                      </v-layout>
                    </template>
                    <template v-else>
                      <div class="caption">{{ $t('Minimum of ... items') }}</div>
                      <v-layout>
                        <v-flex>
                          <input
                            type="number"
                            v-model="coupon.promovalue"
                            min="0"
                            maxlength="5"
                            max="99999"
                            placeholder="Count"
                            name="promovalue"
                            v-validate="'required|numeric'"
                          />

                          <span class="text-error" v-if="errors.has('promovalue')">{{
                            errors.first('promovalue')
                          }}</span>
                        </v-flex>
                        <v-flex shrink class="pa-2">{{ $t('Items') }}</v-flex>
                      </v-layout>
                    </template>
                  </v-flex>
                </v-layout>
                <v-divider class="mb-3"></v-divider>

                <v-layout wrap>
                  <v-flex xs12 sm6 class="pa-1">
                    <div class="caption">{{ $t('Discount for') }}</div>
                    <v-radio-group v-model="coupon.discounttype" :data-vv-as="$t('Discount for')">
                      <v-radio
                        :label="$t('Discount price')"
                        :value="'price'"
                        color="primary"
                      ></v-radio>
                      <v-radio
                        :label="$t('Discount percent')"
                        :value="'percent'"
                        color="primary"
                      ></v-radio>
                      <v-radio
                        :label="$t('Discount shipping fee')"
                        :value="'ship'"
                        color="primary"
                      ></v-radio>
                      <v-radio
                        :label="$t('Free Delivery')"
                        :value="'freeship'"
                        color="primary"
                      ></v-radio>
                    </v-radio-group>
                  </v-flex>
                  <v-flex xs12 sm6 class="pa-1">
                    <template v-if="coupon.discounttype == 'price'">
                      <div class="caption">ลดราคา</div>
                      <v-layout>
                        <v-flex
                          class="form-control"
                          :class="{ 'has-error': errors.has('discountvalue') }"
                        >
                          <input
                            type="number"
                            min="0"
                            maxlength="5"
                            max="99999"
                            v-model="coupon.discountvalue"
                            placeholder="Price"
                            name="discountvalue"
                            v-validate="'required|numeric'"
                          />
                          <span class="text-error" v-if="errors.has('discountvalue')">{{
                            errors.first('discountvalue')
                          }}</span>
                        </v-flex>
                        <v-flex shrink class="pa-2">{{ $t('Baht') }}</v-flex>
                      </v-layout>
                    </template>
                    <template v-else-if="coupon.discounttype == 'percent'">
                      <div class="caption">{{ $t('Discount percent') }}</div>
                      <v-layout>
                        <v-flex
                          class="form-control"
                          :class="{ 'has-error': errors.has('discountvalue') }"
                        >
                          <input
                            type="number"
                            min="0"
                            max="100"
                            maxlength="3"
                            v-model="coupon.discountvalue"
                            placeholder="Price"
                            name="discountvalue"
                            v-validate="'required|numeric|max_value:100|min_value:1'"
                          />
                          <span class="text-error" v-if="errors.has('discountvalue')">{{
                            errors.first('discountvalue')
                          }}</span>
                        </v-flex>
                        <v-flex shrink class="pa-2">%</v-flex>
                      </v-layout>
                    </template>
                    <template v-else-if="coupon.discounttype == 'ship'">
                      <div class="caption">{{ $t('Discount shipping fee') }}</div>
                      <v-layout>
                        <v-flex
                          class="form-control"
                          :class="{ 'has-error': errors.has('discountvalue') }"
                        >
                          <input
                            type="number"
                            min="0"
                            maxlength="5"
                            max="99999"
                            v-model="coupon.discountvalue"
                            placeholder="Price"
                            name="discountvalue"
                            v-validate="'required|numeric|min_value:1'"
                          />
                          <span class="text-error" v-if="errors.has('discountvalue')">{{
                            errors.first('discountvalue')
                          }}</span>
                        </v-flex>
                        <v-flex shrink class="pa-2">{{ $t('Baht') }}</v-flex>
                      </v-layout>
                    </template>
                    <template v-else>
                      <div class="caption">{{ $t('Discount shipping fee') }}</div>
                      <div class="pa-2">{{ $t('Free Delivery') }}</div>
                    </template>
                  </v-flex>
                </v-layout>
              </v-card>
              <v-btn color="primary" @click="nextStep(3)" depressed>{{ $t('Next') }}</v-btn>
              <v-btn flat @click="step = 1">{{ $t('Back') }}</v-btn>
            </v-stepper-content>

            <v-stepper-step step="3" :complete="step > 3">
              {{ $t('Limit number of coupon used') }} ({{ $t('Optional') }})
            </v-stepper-step>
            <v-stepper-content step="3">
              <v-card class="elevation-0 mb-5">
                <v-layout wrap>
                  <v-flex xs12 sm6 class="pa-1 form-control">
                    <div class="caption">{{ $t('1 person/ 1 time') }}</div>
                    <toggle-button
                      :value="coupon.onetimeuse"
                      :sync="true"
                      @change="coupon.onetimeuse = !coupon.onetimeuse"
                      :color="$vuetify.theme.success"
                      :labels="{ checked: 'ON', unchecked: 'OFF' }"
                    />
                  </v-flex>
                  <v-flex xs12 sm6 class="pa-1 form-control">
                    <div class="caption">
                      {{ $t('Number of code that can be used in the campaign') }}
                    </div>
                    <v-layout>
                      <v-flex>
                        <input type="number" v-model="coupon.quantity" maxlength="9999" />
                      </v-flex>
                      <v-flex shrink>
                        <v-btn small fab flat class="my-0" @click="coupon.quantity = null">
                          <v-icon>delete</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
                <v-divider class="my-3" />
                <v-layout>
                  <v-flex>
                    {{ $t('Specific category') }}
                  </v-flex>
                  <v-flex class="text-xs-right">
                    <v-btn small outline color="primary" @click="showCategory = true">
                      <v-icon class="mr-2">add</v-icon> {{ $t('Add') }}
                    </v-btn>
                  </v-flex>
                </v-layout>
                <div class="text-xs-center my-3" v-if="coupon.category.length == 0">
                  {{ $t('coupon for all category') }}
                </div>
                <template v-else>
                  <v-card style="border: 1px solid #eee">
                    <template v-for="(cat, index) in coupon.category">
                      <v-card-text :key="'category_' + cat.id">
                        <v-layout>
                          <v-flex class="pa-2">
                            {{ cat.name }}
                          </v-flex>
                          <v-btn flat fab small class="ma-0" @click="deleteCategory(cat)"
                            ><v-icon>close</v-icon></v-btn
                          >
                        </v-layout>
                      </v-card-text>
                      <v-divider
                        :key="'category_divider_' + cat.id"
                        v-if="coupon.category.length - 1 != index"
                      />
                    </template>
                  </v-card>
                </template>
              </v-card>
              <v-btn color="primary" @click="onsave" depressed>{{ $t('Save') }}</v-btn>
              <v-btn flat @click="step = 2">{{ $t('Back') }}</v-btn>
            </v-stepper-content>
          </v-stepper>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showCategory" scrollable persistent max-width="1000">
      <v-card>
        <v-layout>
          <v-flex class="pa-1 form-control">
            <input type="text" v-model="search" :placeholder="$t('Search')" class="mb-0" />
          </v-flex>
          <v-flex shrink class="text-xs-right">
            <v-btn small fab flat @click="showCategory = false"><v-icon>close</v-icon></v-btn>
          </v-flex>
        </v-layout>
        <v-divider />
        <v-card-text max-height="600">
          <div class="text-xs-center" v-if="loadingCategory">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
          </div>
          <template v-if="filterCategory.length > 0">
            <div
              class="z-border-red"
              style="padding: 15px; margin-bottom: 15px; position: relative; cursor: pointer"
              v-for="(cat, index) in filterCategory"
              :key="'schedule_post_' + index"
            >
              <v-layout>
                <v-flex>
                  <div style="padding-left: 10px;word-break: break-all;">
                    {{ cat.name }}
                  </div>
                </v-flex>

                <v-flex shrink>
                  <v-btn small depressed @click="selectedCategory(cat)">
                    {{ $t('Select') }}
                  </v-btn>
                </v-flex>
              </v-layout>
            </div>
          </template>
          <div class="text-xs-center" v-else>
            No category
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import { ToggleButton } from 'vue-js-toggle-button'
import { mapGetters } from 'vuex'

const dict = {
  en: {
    custom: {
      couponcode: {
        excluded: 'Duplicate Conversation Name'
      }
    }
  },
  th: {
    custom: {
      couponcode: {
        excluded: 'ชื่อบทสนทนาซ้ำ'
      }
    }
  },
  la: {
    custom: {
      couponcode: {
        excluded: 'ເຮັດຊ້ໍາຊື່ການສົນທະນາ'
      }
    }
  }
}

export default {
  props: ['value', 'currentcoupon', 'coupons'],
  data() {
    return {
      showCategory: false,
      step: 1,
      search: '',
      promotypeOptions: ['price', 'piece'],
      discounttypeOptions: ['price', 'percent', 'ship', 'freeship'],
      coupon: {
        name: '', //
        code: '',
        promotype: 'price', // price or piece
        promovalue: 5, // numeric
        discounttype: 'price', // price,percent,ship,freeship
        discountvalue: '100', // numeric
        onetimeuse: true, // true,false
        category: [], // [{id:17465,name:"sadsad"},{....}]
        quantity: null, // limit 999
        status: true // true,false
      }
    }
  },
  mounted() {
    this.$validator.localize(dict)
    if (this.currentcoupon) {
      var coupon = this.currentcoupon
      try {
        coupon.category = JSON.parse(coupon.category)
      } catch (error) {}
      this.coupon = coupon
    }
  },
  components: {
    Multiselect,
    ToggleButton
  },
  computed: {
    ...mapGetters({
      categories: 'getCategories',
      loadingCategory: 'getLoadingCategory'
    }),
    filterCategory() {
      if (!this.categories || this.categories.length == 0) return []
      var category = this.categories.filter(el => {
        return (
          !this.coupon ||
          !this.coupon.category ||
          this.coupon.category.length == 0 ||
          this.coupon.category.findIndex(cat => {
            return el.id == cat.id
          }) == -1
        )
      })

      if (this.search != '') {
        return category.filter(el => {
          return el.name.toLowerCase().includes(this.search.toLowerCase())
        })
      } else {
        return category
      }
    },
    excludeCoupons() {
      var coupons = this.coupons

      if (this.coupon && this.coupon.id) {
        coupons = coupons.filter(el => {
          return this.coupon.id != el.id
        })
      }

      if (coupons.length == 0) {
        return ''
      }

      return coupons
        .map(el => {
          return el.code
        })
        .join(',')
    }
  },
  filters: {
    capitalize(name) {
      return `${name.charAt(0).toUpperCase()}${name.slice(1)}`
    }
  },
  methods: {
    onBlurCode() {
      this.$set(this.coupon, 'code', this.coupon.code.toUpperCase())
    },
    async nextStep(step) {
      var result = await this.$validator.validateAll()
      if (!result) {
        this.goToErrorInput()
        return false
      }

      this.step = step
    },
    deleteCategory(category) {
      var index = this.coupon.category.findIndex(el => {
        return el.id == category.id
      })
      if (index != -1) this.coupon.category.splice(index, 1)
    },
    selectedCategory(category) {
      this.coupon.category.push(category)
    },
    onsave() {
      this.$set(this.coupon, 'code', this.coupon.code.toUpperCase())
      this.$emit('onsave', this.coupon)
      this.coupon = {
        name: '', //
        code: '',
        promotype: 'price', // price or piece
        promovalue: 5, // numeric
        discounttype: 'price', // price,percent,ship,freeship
        discountvalue: '100', // numeric
        onetimeuse: true, // true,false
        category: [], // [{id:17465,name:"sadsad"},{....}]
        quantity: null, // limit 999
        status: true // true,false
      }
      this.errors.clear()
      this.step = 1
      this.$emit('input', false)
    },
    oncancel() {
      this.coupon = {
        name: '', //
        code: '',
        promotype: 'price', // price or piece
        promovalue: 5, // numeric
        discounttype: 'price', // price,percent,ship,freeship
        discountvalue: '100', // numeric
        onetimeuse: true, // true,false
        category: [], // [{id:17465,name:"sadsad"},{....}]
        quantity: null, // limit 999
        status: true // true,false
      }
      this.errors.clear()
      this.step = 1
      this.$emit('input', false)
    },
    onKeyPress(evt) {
      evt = evt ? evt : window.event
      var charCode = evt.which ? evt.which : evt.keyCode
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        (charCode < 65 || charCode > 90) &&
        (charCode < 97 || charCode > 122)
      ) {
        evt.preventDefault()
      } else {
        return true
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/AddCoupon.vue